import { useEffect } from 'react';

export function isPublicEntry(pathname: string, hash: string, token: string | null) {
  return (pathname === '/' || pathname === '/index.html') && !hash && !token;
}

export default function PublicEntry() {
  useEffect(() => { window.location.replace('/about.html'); }, []);
  return <main style={{ padding: 32, color: '#fff' }}>
    <h1>小本本</h1>
    <p>正在打开产品介绍。<a href="/about.html" style={{ color: '#a7e6d0' }}>查看官网</a></p>
    <p><a href="/#/login" style={{ color: '#a7e6d0' }}>进入网页版</a></p>
  </main>;
}
